import api from '@edu-fe/api'

const module = {
  name: 'recommend',

  banner: (client = 5) => api.create(`/operation/banner?client=${client}`),

  vip: api.create(`/vip`),

  operation: (client = 2) => api.create(`/operation/columns?client=${client}`),

  getNewClasses: (pageNo = 1, pageSize = 3) => api.create(`/course/new/recommend?client=2&pageNo=${pageNo}&pageSize=${pageSize}`),

  getOperationBar: api.create('/operation/index'),

  getTopLists:(pageNo = 1, pageSize = 3) => api.create(`/course/top/30/recommend?client=2&pageNo=${pageNo}&pageSize=${pageSize}`),

  getLimitLists: (pageNo = 1, pageSize = 3) => api.create(`/course/limit/buy?client=2&pageNo=${pageNo}&pageSize=${pageSize}`),

  getSuperOperation: api.create(`/super/briefing/operation`),
  getRadio: api.create('/operation/radios')
}

export default module
